<template>
  <TransitionRoot as="template" :show="modelValue">
    <Dialog
      :open="modelValue"
      as="div"
      class="fixed z-50 inset-0 overflow-y-auto"
      @close="!fixed && $emit('update:modelValue', false)"
    >
      <div class="flex relative items-center justify-center px-4 text-center">
        <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-0 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="absolute top-0 align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 mt-0 pt-0"
            :class="{
              'max-w-lg w-full': !fullWidth,
              'w-full': fullWidth,
            }"
          >
            <div class="sm:flex sm:items-start pt-2">
              <div
                v-if="icon"
                class="-mt-2 mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
              >
                <i :class="icon"></i>
              </div>
              <div class="mt-3 sm:mt-0 text-left flex-1">
                <DialogTitle v-if="title" as="h3" class="text-lg leading-6 font-medium text-gray-900">
                  {{ title }}
                </DialogTitle>
                <div :class="{ 'mt-2': icon }">
                  <slot></slot>
                </div>
              </div>
            </div>
            <div v-if="close || confirm" class="mt-5 sm:mt-4 sm:flex sm:justify-end gap-x-2 pt-8">
              <button
                v-if="close"
                :class="closeClass"
                type="button"
                class="btn font-normal"
                @click="$emit('update:modelValue', false)"
              >
                {{ closeText || 'Close' }}
              </button>
              <button
                v-if="confirm"
                :class="confirmClass"
                type="button"
                class="btn font-normal"
                @click="
                  () => {
                    $emit('confirm', true)
                    $emit('update:modelValue', false)
                  }
                "
              >
                Confirm
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogTitle, DialogOverlay } from '@headlessui/vue'
import { TransitionRoot, TransitionChild } from '@headlessui/vue'

export default {
  components: {
    Dialog,
    DialogTitle,
    DialogOverlay,
    TransitionRoot,
    TransitionChild,
  },
  emits: ['update:modelValue', 'confirm'],
  props: {
    fixed: Boolean,
    modelValue: Boolean,
    fullWidth: Boolean,
    close: Boolean,
    confirm: Boolean,
    closeText: String,
    closeClass: String,
    confirmClass: String,
    title: String,
    icon: String,
  },
}
</script>

<style></style>
